import * as React from "react";
import styled from "styled-components";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

interface ReleaseDetailDeleted {
  deleteMessage: string;
}

export const ReleaseDetailDeleted: React.FC<ReleaseDetailDeleted> = ({
  deleteMessage,
}) => {

  return (
    <React.Fragment>
      <DeleteIcon/ >
      <ErrorMessage> Release Not Found! </ErrorMessage>
      <ErrorCaption> {deleteMessage} </ErrorCaption>
    </React.Fragment>
  );
};

const ErrorMessage = styled.h2``;

const DeleteIcon = styled(DeleteForeverIcon)`
  width: 2em;
  height: 2em;
`;

const ErrorCaption = styled.p``;
